"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M10.33 3.842 8.864 1.434 7.396 3.842a.671.671 0 0 1-.948.207l-.267-.18.476 3.207c.092.621-.65 1.014-1.114.59l-1.529-1.39-.14.356a.67.67 0 0 1-.745.412L1.476 6.74l.483 1.952a.666.666 0 0 1-.245.691l-.33.251 3.572 3.01v2.206l-.434.055A.668.668 0 0 1 3.815 14l.255-.646-3.833-3.227a.666.666 0 0 1 .027-1.041l.541-.41-.578-2.338a.668.668 0 0 1 .771-.816l1.973.363.243-.616A.67.67 0 0 1 4.29 5.02l1.08.983-.44-2.971a.67.67 0 0 1 1.038-.65l.719.484L8.236.321A.67.67 0 0 1 8.808 0h.11a.67.67 0 0 1 .573.321l1.55 2.545.72-.484a.67.67 0 0 1 1.037.65l-.44 2.971 1.08-.983a.67.67 0 0 1 1.075.248l.243.616 1.973-.363a.668.668 0 0 1 .771.816l-.578 2.338.54.41a.666.666 0 0 1 .028 1.04l-.522.44H15.24l1.105-.93-.331-.252a.666.666 0 0 1-.245-.69l.483-1.953-1.654.304a.67.67 0 0 1-.744-.412l-.141-.355-1.529 1.39c-.465.423-1.206.03-1.114-.59l.476-3.208-.267.18a.671.671 0 0 1-.948-.207ZM6.14 23v.442a.558.558 0 0 0 1.116 0v-1.757h15.07c.924 0 1.674-.747 1.674-1.668v-6.672a1.67 1.67 0 0 0-1.674-1.668H7.814a1.67 1.67 0 0 0-1.674 1.668V23Zm1.674-10.211a.557.557 0 0 0-.558.556v2.78h5.581v-3.336H7.814Zm6.14 1.112h8.93v-.556a.557.557 0 0 0-.558-.556h-8.373V13.9Zm8.93 1.112h-8.93v1.112h8.93v-1.112Zm0 3.336v-1.112H7.256v1.112h15.628Zm0 1.112H7.256v1.112h15.07a.557.557 0 0 0 .558-.556v-.556Z",
    clipRule: "evenodd"
  })]
});